<script setup lang="ts">
import { computed } from 'vue';
import { getOptimizedImageSrc } from '@/directives/optimizedImageSize';
import { IProfile } from '@/interfaces';

const emit = defineEmits([
  'profile-selected',
  'save',
  'department-selected',
  'close',
]);

interface Props {
  profiles: IProfile[];
}

const props = withDefaults(defineProps<Props>(), {});

const size = computed(() => {
  return props.profiles.length > 25 ? 'small' : 'large';
});

const selectProfile = (profile: IProfile) => {
  emit('profile-selected', profile);
};
</script>

<template>
  <div class="flex flex-col mb-12">
    <div class="flex flex-col h-full relative">
      <div
        class="grid grid-cols-3 gap-y-10 pt-12 max-h-full"
        :class="{
          'grid-cols-3 gap-x-4': size === 'large',
          'grid-cols-5 gap-x-0': size !== 'large',
        }"
      >
        <div
          v-for="(profile, index) in profiles"
          :key="index"
          data-pressable
          class="profile flex flex-col items-center"
          :class="{ 'h-36': size !== 'large', 'h-60': size === 'large' }"
          @click="selectProfile(profile)"
        >
          <img
            class="profileImage rounded-full shadow-lg object-cover mb-4"
            :src="getOptimizedImageSrc(profile.displayImage, 'small')"
            :class="[size]"
          />
          <p class="text-2xl font-bold text-center">
            {{ profile.displayName }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.profile {
  &.inline {
    display: flex;
    align-items: center;
    margin-left: 40px;
  }

  .profileImage {
    &.small {
      width: 96px;
      height: 96px;
    }

    &.large {
      width: 190px;
      height: 190px;
    }
  }
}
.select-el {
  bottom: 250px;
}
</style>
